import pathname, { menuType } from '../../../constants/pathname'

export const evaluatesSchema = {
  alwaysOpenKeys: ['1', '2'],
  menu: menuType.auditSchema,
  sidebars: [
    {
      id: 'section1',
      type: 'nav',
      items: [
        {
          eventKey: '1-1',
          icon: {
            name: 'chevron-circle-right',
          },
          link: pathname.evaluates.CoworkerEvaluateYourself,
          children: 'การประเมินโดยภาคี ',
        },
      ],
    },
    {
      id: 'section2',
      type: 'nav',
      items: [
        {
          eventKey: '2-1',
          icon: {
            name: 'chevron-circle-right',
          },
          link: pathname.evaluates.CoordinatorEvaluateCoworker,
          children: 'การประเมินโดยนักวิชาการ ',
        },
      ],
    },

    {
      id: 'section3',
      type: 'nav',
      items: [
        {
          eventKey: '3-1',
          icon: {
            name: 'chevron-circle-right',
          },
          link: pathname.evaluates.DirectorEvaluateCloseProject,
          children: 'ผลการประเมิน ',
        },
      ],
    },
  ],
}
